import _ from 'lodash'
import * as moment from 'moment'

import { BaseDto } from "./base.dto"
import { FileDto } from "./file.dto"
import { PagingDto } from "./paging.dto"
import { TranslationDto } from './translation.dto'

export class PromotionDto extends BaseDto {
  title: TranslationDto
  thumbnail: FileDto
  startDate: Date
  endDate: Date
  enabled: boolean
  mallId: string
}

export class PromotionDetailDto extends BaseDto {
  title?: TranslationDto
  content?: TranslationDto
  thumbnail?: FileDto
  image?: FileDto
  mobileImage?: FileDto
  startDate?: Date
  endDate?: Date
  publishedNotification?: boolean
  enabled?: boolean
  mallId?: string

  static create({ id, title, enabled, thumbnail, startDate, endDate, mobileImage, image, content, mallId }: PromotionDetailDto) {
    return _.assign<PromotionDetailDto>({
      title: title || TranslationDto.create(),
      content: content || TranslationDto.create(),
      enabled: enabled,
      thumbnail: thumbnail || null,
      mobileImage: mobileImage || null,
      image: image || null,
      thumbnailId: thumbnail ? thumbnail.id : null,
      imageId: image ? image.id : null,
      mobileImageId: mobileImage ? mobileImage.id : null,
      startDate: moment(startDate).toDate() || null,
      endDate: moment(endDate).toDate() || null,
      mallId: mallId || null
    })
  }
}

export class CreatePromotionDto {
  title: TranslationDto
  content: TranslationDto
  thumbnailId: string
  imageId: string
  mobileImageId: string
}

export class UpdatePromotionDto {
  title?: TranslationDto
  content?: TranslationDto
  thumbnailId?: string
  imageId?: string
  mobileImageId?: string
  enabled?: boolean
}

export class FindPromotionDto extends PagingDto {
  searchText?: string
  mallId?: string
  getAll?: boolean
}